import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { API } from "../cache";

const PermissionsContext = createContext(null);

export function PermissionsProvider({ children }) {
  const [perms,   setPerms]   = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    fetch(`${API}/rbac/my-permissions`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setPerms(data || null))
      .catch(() => setPerms(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <PermissionsContext.Provider value={{ perms, loading, reload: load }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsContext);
}
